import { LoanStatus } from '@willow/types-iso';

import { assertNever } from './assertNever';

/** In both the app and portal, we treat active and pre-active the same */
export function formatLoanStatus(status: LoanStatus): string {
  switch (status) {
    case 'active':
    case 'preActive':
    case 'foreclosure': // @migrationTodo remove foreclosure from array after migration to remove it as a status
      return 'Active';
    case 'pendingActivation':
      return 'Pending Activation';
    case 'pendingTransfer':
      return 'Pending Transfer';
    case 'transferred':
      return 'Transferred';
    case 'archived':
      return 'Archived';
    case 'paidOff':
      return 'Paid Off';
    case 'reo':
      return 'REO';
    case 'liquidated':
      return 'Liquidated';
    default:
      assertNever(status);
  }
}
